import { RoutingState } from 'src/modules/routing/types/RoutingState';
import { RootState } from 'src/types/RootState';

export const getRoutingState = (state: RootState): RoutingState => state.routing;
